import * as React from 'react';
import { ComponentProps } from 'lib/component-props';
import { StNextImage } from '../../shared/NextImage.styles';
import Box from '@mui/material/Box';
import {
  Field,
  ImageField,
  RichText,
  RichTextField,
  Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { SmallBannerWrapper, getMargin } from './SmallBanner.style';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import UiText from '../../../components/shared/Typography/UiText';
import UiSubHeading from '../../../components/shared/Typography/UiSubHeading';
import useApplyV2Theme from '../../../lib/hooks/useApplyV2Theme';
import { Typography } from '@mui/material';

export type ISmallBannerProps = ComponentProps & {
  fields: {
    description?: RichTextField;
    title?: Field<string>;
    titleIcon?: ImageField;
    applyMargin?: Field<boolean>;
  };
};

const iconDimentions = {
  desktop: { height: 70, width: 60 },
  tablet: { height: 60, width: 50 },
  mobile: { height: 48, width: 38 },
};

const SmallBanner = (props: ISmallBannerProps): JSX.Element => {
  const { isToapplyV2Theme } = useApplyV2Theme();
  const theme = useTheme();
  const themeColor = theme?.palette?.themeColor?.main;
  const {
    description = { value: '' },
    title = { value: '' },
    titleIcon = { value: { src: '' } },
    applyMargin = { value: false },
  } = props?.fields;
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { desktop, mobile, tablet } = iconDimentions;
  if (!props?.fields) return <></>;
  let { height, width } = desktop;
  if (isTablet && !isMobile) {
    height = tablet.height;
    width = tablet.width;
  }
  if (isMobile) {
    height = mobile.height;
    width = mobile.width;
  }

  return (
    <SmallBannerWrapper id="small-banner" sx={getMargin(applyMargin.value, theme)}>
      <Box>
        <StNextImage suppressHydrationWarning field={titleIcon} width={width} height={height} />
      </Box>
      {isToapplyV2Theme ? (
        <UiSubHeading
          color={'primary'}
          styles={{
            fontSize: '20px',
            fontWeight: '600',
            lineHeight: '32px',
          }}
        >
          {title?.value}
        </UiSubHeading>
      ) : (
        <Typography
          variant="h4"
          color={themeColor}
          paddingTop={'8px'}
          sx={{
            textAlign: 'center',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '32px',
          }}
        >
          <Text data-testid={props?.fields?.title} field={props?.fields?.title} />
        </Typography>
      )}

      {isToapplyV2Theme ? (
        <UiText
          color={'primary'}
          styles={{
            fontSize: '20px',
            lineHeight: '32px',
            fontWeight: 400,
          }}
        >
          <RichText field={description} />
        </UiText>
      ) : (
        <Box
          sx={{
            paddingTop: '8px',
            color: themeColor,
            textAlign: 'center',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
            [theme.breakpoints.down('md')]: {
              fontSize: '16px',
              fontStyle: 'normal',
              lineHeight: '24px',
              paddingInline: '1.5rem',
            },
          }}
        >
          <RichText field={props?.fields?.description} />
        </Box>
      )}
    </SmallBannerWrapper>
  );
};

export default SmallBanner;
